import styled, { css } from 'styled-components'
import theme from '../../../../styles/theme'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`
export const ContentCard = styled.p`
  font-weight: 300;
  color: ${theme.colors.darkGray};
  margin-bottom: 30px;
`
export const ActionsCard = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  span {
    display: flex;
    & > button {
      margin-right: 7px;
    }
  }
`
export const PaymentRow = styled.div`
  display: flex;
  margin-top: 15px;
`
export const BoxItemValue = styled.div`
  margin-right: 45px;
`
export const LabelStyled = styled.div`
  font-weight: 300;
  color: ${theme.colors.gray};
  font-size: 0.7rem;
`
export const ValueStyled = styled.div`
  font-weight: 400;
  color: ${theme.colors.darkGray};
  font-size: 0.8rem;
`
export const HeaderCard = styled.div``
export const SubtitleHeaderCard = styled.h6`
  font-weight: 300;
  color: ${theme.colors.darkGray};
`
export const TitleHeaderCard = styled.h3`
  font-weight: 500;
  color: ${theme.colors.black};
`
export const TitleInternal = styled.h2`
  font-weight: 300;
  color: ${theme.colors.darkGray};
`
export const Card = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    border-radius: ${theme.border.cardRadius};
    width: 100%;
    padding: 20px 20px;
    border: 1px solid ${theme.colors.xxlightGray};
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-top: 30px;
    align-self: center;
  `}
`
